import router from "@/router";
import store from "@/store";
import {StoreAction} from "@/store/actions";
import {Route} from "vue-router/types/router";
import {RoutsData} from '@/router/routs';

const emptyPromise = new Promise(() => {
});

/**
 * Глобальная обработка HTTP-ошибок
 */
export function httpErrorHandler (error: any): any {
  // Ошибки бизнес-логики пробрасываем дальше для обработки в компонентах
  return error.response.status === 418 ? Promise.reject(error.response.data) : handleSystemError(error);
}

/**
 * Обработка системных ошибок
 */
function handleSystemError(error: any): Promise<any> {
  switch (error.response.status) {
    case 400:
      return handle400BadRequest();
    case 401:
      return handle401Unauthorized(error);
    case 403:
      return handle403Forbidden();
    case 500:
      return handle500InternalServerError(error);
    default:
      return handleUnknownError(error);
  }
}

/**
 * Обработка HTTP-кода 400
 */
function handle400BadRequest(): Promise<any> {
  // TODO: реализовать
  return emptyPromise;
}

/**
 * Обработка HTTP-кода 401
 */
function handle401Unauthorized(error: any): Promise<any> {

  // Получаем состояние флага "запрошен маршрут для логина"
  const loginRouteRequested: boolean = store.getters.loginRouteRequested;

  // Получаем последний запрошенный маршрут
  const lastRequestedRoute: Route = store.getters.lastRequestedRoute;

  // Очистка состояния приложения
  return store.dispatch(StoreAction.CLEAR_STATE).then(() => {

    if (router.currentRoute.name !== RoutsData.LOGIN.name) {

      router.push({
        name: RoutsData.LOGIN.name,
        query: {redirect: lastRequestedRoute.path}
      });

      return emptyPromise;
    }

    return Promise.reject(error);
  });
}

/**
 * Обработка HTTP-кода 403
 */
function handle403Forbidden(): Promise<any> {
  // TODO: реализовать
  return emptyPromise;
}

/**
 * Обработка HTTP-кода 500
 */
function handle500InternalServerError(error: any): Promise<any> {

  return Promise.reject(error);
}

/**
 * Обработка неизвестной ошибки
 */
function handleUnknownError(error: any): Promise<any> {
  // TODO: реализовать
  return Promise.reject(error);
}
